<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PrintOptions from "@/components/modals/print-options.vue";
import { cloneDeep, groupBy } from "lodash";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import PlanningTemplate from "./planning-template.vue";
import PlanningRatingScale from "@/components/modals/planning-rating-scale.vue";
import RawData from "@/components/widgets/raw-data.vue";
export default {
  page: {
    title: "Cascaded Targets",
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    PrintOptions,
    PlanningTemplate,
    PlanningRatingScale,
    RawData
  },
  data() {
    return {
      title: "Cascaded Targets",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Cascaded Templates",
          active: true,
        },
      ],
      cycles: [],
      selectedDU: [],
      filterDUs: "",
      totalOPCR: 0,
      opcrs: [],
      loadOPCR: false,
      campusTemplates: [],
      campusBusy: false,
      indicators: [],
      mandatoryApis: [],
      modalTitle: "",
      pp: {
        id: 0,
        planningMainTargetId: 0,
        q1: 0,
        q1Text: null,
        q2: 0,
        q2Text: null,
        q3: 0,
        q3Text: null,
        q4: 0,
        q4Text: null,
        points: 0,
        deliveryUnitId: 0,
        description: null,
      },
      currencyMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false,
        allowDecimal: true,
      }),
      itemClassifications: [],
      selectedTemplate: {},
      selectedTargetData: null,
      rating: [],
      ratingBusy: false,
      selectedDeliveryUnit: null,
      postedOPCRs: [],
      tabOptions: [
        "Strategic Priority",
        "Core Functions",
        "Mandatory Support Function",
      ],
      returnForm: {
        id: 0,
        remarks: "",
      },
      opcrStatus: "Pending",
      opcrBusy: false,
      selectedParent: null
    };
  },
  computed: {
    filteredOffices() {
      let data = this.campusTemplates;
      if (this.filterDUs.trim() != "" && this.filterDUs) {
        data = data.filter((item) => {
          return item.filterKey
            .toUpperCase()
            .includes(this.filterDUs.toUpperCase());
        });
      }
      return data;
    },
  },
  async mounted() {
    this.pageLoader(true);
    await this.getCycle();
    await this.changeCycle(this.$store.state.data.cycle, true);
    await this.getIndicators();
    await this.getMandatoryApis();
    await this.getClassifications();
    await this.getCampusTemplates(
      this.$store.state.data.cycle,
      this.$store.state.data.selectedCampus.id
    );
    this.pageLoader(false);
  },
  validations: {
    pp: {
      description: { required },
    },
    returnForm: { remarks: { required } },
  },
  methods: {
    groupedTargets(props) {
      var array = [];
      var x = groupBy(props, "planningMainTarget.indicatorItemId");
      for (const xKey in x) {
        var indicatorItemId = xKey;
        var y = groupBy(
          x[xKey],
          "planningMainTarget.indicatorItem.indicatorItemName"
        );
        for (const yKey in y) {
          var indicatorItemName = yKey;
          var z = groupBy(
            y[yKey],
            "planningMainTarget.indicatorItem.indicatorItemClassification.classification"
          );
          for (const zKey in z) {
            array.push({
              indicatorItemId: indicatorItemId,
              indicatorItemName: indicatorItemName,
              allowText: z[zKey][0].planningMainTarget.indicatorItem.allowText,
              indicatorItemClassification: zKey,
              details: z[zKey],
              showTargets: false,
            });
          }
        }
      }
      return array;
    },
    filteredTargets(props) {
      let data = props.targets;
      data = data.filter((item) => {
        if (props.tabSelect == "Strategic Priority")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (props.tabSelect == "Core Functions")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("CORE");
        else if (props.tabSelect == "Mandatory Support Function")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("MANDATORY");
        else return item;
      });
      if (props.filter.trim() != "" && props.filter) {
        data = data.filter((item) => {
          if (
            item.indicatorItemName
              .toUpperCase()
              .includes(props.filter.toUpperCase())
          )
            return item.indicatorItemName
              .toUpperCase()
              .includes(props.filter.toUpperCase());
          if (
            item.details.filter((targetItem) => {
              if (
                targetItem.searchKey
                  .toUpperCase()
                  .includes(props.filter.toUpperCase())
              )
                return targetItem.searchKey
                  .toUpperCase()
                  .includes(props.filter.toUpperCase());
            }).length
          ) {
            return item.details.filter((targetItem) => {
              if (
                targetItem.searchKey
                  .toUpperCase()
                  .includes(props.filter.toUpperCase())
              )
                return targetItem.searchKey
                  .toUpperCase()
                  .includes(props.filter.toUpperCase());
            });
          }
        });
      }
      return data;
    },
    async getClassifications() {
      this.$store
        .dispatch("indicatoritemclassification/GetIndicatorItemClassification")
        .then((res) => {
          this.itemClassifications = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getCycle() {
      var cycles = [{ text: "", value: 0 }];
      this.$store
        .dispatch("cycle/GetAllCycle")
        .then((res) => {
          res.data.forEach((item) => {
            cycles.push({ value: item.year, text: item.year });
          });
          this.cycles = cycles;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async changeCycle(cycle, first) {
      this.getIndicators();
      this.getPreplanning(cycle, this.$store.state.data.selectedCampus.id);
      this.getOPCRsByDU(cycle, this.$store.state.data.selectedCampus.id);
      if (!first) {
        this.getCampusTemplates(
          cycle,
          this.$store.state.data.selectedCampus.id
        );
      }
    },
    async changeCampus(campusId) {
      this.getIndicators();
      this.getPreplanning(this.$store.state.data.cycle, campusId);
      this.getCampusTemplates(this.$store.state.data.cycle, campusId);
      this.getOPCRsByDU(this.$store.state.data.cycle, campusId);
      this.selectedDU = [];
    },
    async getPreplanning(cycle, campusId) {
      this.tableBusy = true;
      this.preplanningData = [];
      await this.$store
        .dispatch("preplanningtarget/GetPrePlanningTargets", {
          cycle,
          campusId,
        })
        .then((res) => {
          if (res.data.error) {
            this.tableBusy = false;
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            item.filterKey = `${item.indicatorItem.indicatorItemName} ${item.description}`;
            item.viewOffices = false;
            item.targetTemplateDeliveryUnits.forEach((y) => {
              y.editMode = false;
            });
            item.addDU = false;
            item.checkTemplate = false;
            item.campusId = "";
            item.campus = {};
            item.deliveryUnitId = "";
            item.du = {};
          });
          this.preplanningData = res.data;
        })
        .catch((err) => {
          this.showToast(
            "Something went wrong! - getting preplanning",
            "error"
          );
        });
      this.tableBusy = false;
    },
    async getCampusTemplates(cycle, campusId) {
      this.campusBusy = true;
      this.campusTemplates = [];
      this.totalOPCR = 0;
      await this.$store
        .dispatch("planningtarget/GetSummaryPostedByCampus", {
          cycle,
          campusId,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.map((x) => {
            x.officeName = x.office.name;
            x.filterKey = `${x.office.name}`;
            x.deliveryUnits.forEach((y) => {
              y.filterKey = `${y.deliveryUnit.name}`;
              x.filterKey += ` ${y.deliveryUnit.name}`;
              y.targetLoading = false;
              y.targets = [];
              y.rotateChevy = false;
              y.count > 0 && this.totalOPCR++;
              y.tabIndex = 0;
              y.tabSelect = "Strategic Priority";
              y.filter = "";
            });
          });
          this.campusTemplates = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
      this.campusBusy = false;
    },
    async getIndicators() {
      await this.$store
        .dispatch("indicator/GetIndicator")
        .then((res) => {
          res.data.map((item) => {
            item.filterKey = item.prexc + ' ' + item.indicatorName;
            item.indicatorItems.forEach((x) => {
              item.filterKey += ` ${x.indicatorItemName}`;
            });
            item.indicatorItemLoading = false;
            item.fetchedIndicatorItems = [];
            item.openFI = false;
            item.prexcGrp = item.prexc.replace(/\s/g, "").toLowerCase();
            item.prexcClassGrp = item.prexcClassification.replace(/\s/g, "").toLowerCase();
            item.searchFilter = "";
          });
          // this.indicators = res.data;
          let classGrp = groupBy(res.data, "prexcClassGrp");
          let grpData = [];
          let itemClasses = [];
          for (const [key, value] of Object.entries(classGrp)) {
            let grp = groupBy(value, "prexcGrp");
            let resData = [];
            let upFilterKey = "";
            for (const [gKey, gValue] of Object.entries(grp)) {
              let filterKey = "";
              gValue.map(y => {
                y.indicatorItems.map(x => {
                  filterKey += x.indicatorItemName + " ";
                  if(!itemClasses.find(w => w == x.indicatorItemClassification)){
                    itemClasses.push(x.indicatorItemClassification);
                  }
                  upFilterKey += x.indicatorItemName + " ";
                });
                filterKey += y.indicatorName + " ";
                upFilterKey += y.indicatorName + " ";
              })
              resData.push({
                id: gValue[0].prexcId,
                prexc: gValue[0].prexc,
                items: gValue,
                rotateChevy: false,
                filterKey: filterKey + ` ${gValue[0].prexc}`,
                searchClass: itemClasses.join(" "),
              });
              upFilterKey += gValue[0].prexc + " " + gValue[0].indicatorName;
            }
            grpData.push({
              id: key,
              prexcClass: value[0].prexcClassification,
              items: resData,
              filterKey: upFilterKey + ` ${value[0].prexcClassification}`,
              searchClass: itemClasses.join(" "),
            });
          }
          this.indicators = grpData;
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting indicators", "error");
        });
    },
    async getMandatoryApis() {
      this.$store
        .dispatch("apitemplate/GetPriorityApiTemplate")
        .then((res) => {
          res.data.map((item) => {
            item.selected = false;
          });
          this.mandatoryApis = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getOPCRsByDU(cycle, campusId) {
      let url = "";
      if (this.opcrStatus == "Pending") {
        url = "GetPostedPlanningOPCR";
      } else {
        url = "GetApprovedPlanningOPCR";
      }
      this.opcrBusy = true;
      await this.$store
        .dispatch(`preopcr/${url}`, {
          campusId,
          cycle,
        })
        .then((res) => {
          this.opcrBusy = false;
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.map((item) => {
            item.showTargets = false;
            item.targets = [];
            item.loadTarget = false;
            item.showLibs = false;
            item.libs = [];
            item.loadLib = false;
          });
          var grouped = groupBy(res.data, "deliveryUnitId");
          var data = [];
          for (var key in grouped) {
            data.push({
              deliveryUnitId: key,
              deliveryUnit: grouped[key][0].deliveryUnit,
              count: grouped[key].length,
              opcrs: grouped[key],
            });
          }
          this.postedOPCRs = data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async viewTargets(data) {
      if (data.count == 0) {
        return;
      }
      data.rotateChevy = !data.rotateChevy;
      if (data.rotateChevy) {
        data.targetLoading = true;
        await this.getTargets(data);
        setTimeout(() => {
          data.targetLoading = false;
        }, 500);
      }
    },
    async getTargets(row) {
      await this.$store
        .dispatch("planningtarget/GetPostedPlanningTargetByDU", {
          deliveryUnitId: row.deliveryUnitId,
          cycle: this.$store.state.data.cycle,
        })
        .then((res) => {
          if (res.data) {
            res.data.map((item) => {
              item.apiLoading = false;
              item.rotateChevy = false;
              item.apiList = [];
              item.tags = [];
              item.searchKey = `${item.planningMainTarget.indicatorItem.indicatorItemName} ${item.description}`;
            });
            row.targets = this.groupedTargets(res.data);
          } else {
            row.targets = [];
          }
          this.setTabSelect(row);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getApiList(y) {
      y.rotateChevy = !y.rotateChevy;
      if (y.apiList.length == 0 && y.rotateChevy) {
        y.apiLoading = true;
        await this.$store
          .dispatch("planningapi/GetPlanningApisByTarget", y.id)
          .then((res) => {
            if (res.data) {
              res.data.forEach((x) => {
                x.viewResource = false;
                x.resourceList = [];
                x.resourceLoading = false;
              });
              y.apiList = res.data;
            } else {
              y.apiList = [];
            }
          })
          .catch(() => {
            this.showToast("Something went wrong!", "error");
          });
        y.apiLoading = false;
      }
    },
    setTabSelect(row) {
      row.tabSelect = this.checkTab(row.targets, "Strategic Priority")
        ? "Strategic Priority"
        : this.checkTab(row.targets, "Core Functions")
        ? "Core Functions"
        : "Mandatory Support Function";
    },
    checkTab(dataArray, type) {
      let data = dataArray;
      data = data.filter((item) => {
        if (type == "Strategic Priority")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (type == "Core Functions")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("CORE");
        else if (type == "Mandatory Support Function")
          return item.indicatorItemClassification
            .toUpperCase()
            .includes("MANDATORY");
      });
      return data.length > 0 ? true : false;
    },
    autoGrowTemplate(element, size) {
      element.style.height = `${size}px`;
      element.style.height = `${element.scrollHeight}px`;
    },
    autoGrow(element, size) {
      element.target.style.height = `${size}px`;
      element.target.style.height = `${element.target.scrollHeight}px`;
    },
    getPerformanceRating(row, type) {
      this.$bvModal.show("performance-rating-modal");
      this.$refs.PlanningRatingScale.setMeasurement(row, type);
    },
    async getResource(y) {
      y.viewResource = !y.viewResource;
      if (y.resourceList.length == 0 && y.viewResource) {
        y.resourceLoading = true;
        await this.$store
          .dispatch("planningapiresource/GetPlanningApiResourcesByApi", y.id)
          .then((res) => {
            res.data.map((x) => {
              x.totalQuantity = 0;
              x.planningApiResourceDetails.forEach((z) => {
                x.totalQuantity += z.quantity;
              });
            });
            y.resourceList = res.data;
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
        y.resourceLoading = false;
      }
    },
    deleteTargetItem(row, parent, grandparent) {
      var index = parent.details.findIndex((x) => x.id == row.id);
      var gInd = grandparent.targets.findIndex((x) => x.id == row.id);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("planningtarget/DeletePlanningTarget", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              parent.details.splice(index, 1);
              grandparent.targets.splice(gInd, 1);
              grandparent.count--;
              this.showToast("Successfully deleted!", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    async printOPCR(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/OPCR",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async printDULIB(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/LIB",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async printPPMP(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/PPMP/OPCR",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async printPPMPAPI(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/PPMP/API",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    showOPCRs(row) {
      this.modalTitle = `OPCRs for ${
        row.deliveryUnit.name.length > 30
          ? `${row.deliveryUnit.name.slice(0, 30)}...`
          : row.deliveryUnit.name
      }`;
      this.$bvModal.show("opcr-modal");
      this.getOPCRs(row.deliveryUnitId);
    },
    async getOPCRs(id) {
      this.loadOPCR = true;
      await this.$store
        .dispatch("preopcr/GetPostedPreOpcr", {
          cycle: this.$store.state.data.cycle,
          deliveryUnitId: id,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.opcrs = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      this.loadOPCR = false;
    },
    updateTargetItem(row, parent, grand) {
      this.selectedParent = parent;
      this.pp = {
        id: row.id,
        planningMainTargetId: row.planningMainTargetId,
        q1: cloneDeep(row.q1.toString()),
        q1Text: cloneDeep(row.q1Text),
        q2: cloneDeep(row.q2.toString()),
        q2Text: cloneDeep(row.q2Text),
        q3: cloneDeep(row.q3.toString()),
        q3Text: cloneDeep(row.q3Text),
        q4: cloneDeep(row.q4.toString()),
        q4Text: cloneDeep(row.q4Text),
        points: cloneDeep(row.points.toString()),
        deliveryUnitId: grand.deliveryUnitId,
        description: cloneDeep(row.description),
        allowEdit: cloneDeep(row.allowEdit),
      };
      this.modalTitle = "Update Target";
      this.$bvModal.show("update-target-modal");
    },
    async onUpdateTarget() {
      this.submitted = true;
      this.$v.pp.$touch();
      if (this.$v.pp.$invalid) {
        return;
      }
      if(this.selectedParent.allowText){
        if(this.pp.q1Text.trim() == '' || this.pp.q2Text.trim() == '' || this.pp.q3Text.trim() == '' || this.pp.q4Text.trim() == ''){
          return;
        }
      }else{
        if(isNaN(this.pp.q1) || this.pp.q1.trim() == ''
        || isNaN(this.pp.q2) || this.pp.q2.trim() == ''
        || isNaN(this.pp.q3) || this.pp.q3.trim() == ''
        || isNaN(this.pp.q4) || this.pp.q4.trim() == ''){
          return;
        }
      }
      let data = cloneDeep(this.pp);
      data.q1 = this.getExactAmt(this.pp.q1 || '0');
      data.q2 = this.getExactAmt(this.pp.q2 || '0');
      data.q3 = this.getExactAmt(this.pp.q3 || '0');
      data.q4 = this.getExactAmt(this.pp.q4 || '0');
      await this.$store
        .dispatch("planningtarget/UpdatePlanningTarget", this.pp)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          let index = this.selectedParent.details.findIndex(
            (x) => x.id == this.pp.id
          );
          this.selectedParent.details[index].description = cloneDeep(
            this.pp.description
          );
          for(let i = 1; i <=4; i++){
            this.selectedParent.details[index][`q${i}`] = this.pp[`q${i}`];
            this.selectedParent.details[index][`q${i}Text`] = this.pp[`q${i}Text`];
          }
          this.selectedParent.details[index].points = cloneDeep(this.pp.points);
          this.$bvModal.hide("update-target-modal");
          this.showToast("Successfully updated!", "success");
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    removeApi(row, parent) {
      var index = parent.apiList.indexOf(row);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("planningapi/DeletePlanningApi", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (res.status == 204) {
                parent.apiList.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              }
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    filteredDUs(items) {
      let data = items;
      if (this.filterDUs.trim() != "" && this.filterDUs) {
        data = data.filter((item) => {
          return item.filterKey
            .toUpperCase()
            .includes(this.filterDUs.toUpperCase());
        });
      }
      return data;
    },
    returnOPCR(opcr) {
      this.returnForm = {
        id: opcr.id,
        remarks: "",
      };
      this.$bvModal.show("return-modal");
    },
    async returnOPCRSubmit() {
      this.submitted = true;
      this.$v.returnForm.$touch();
      if (this.$v.returnForm.$invalid) {
        return;
      }
      await this.$store
        .dispatch("preopcr/ReturnPlanningPreOpcr", this.returnForm)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.$refs.postedData.removeOPCR(this.returnForm.id);
          this.$bvModal.hide("return-modal");
          this.showToast("Successfully returned", "success");
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    changeOPCRStatus(status) {
      this.opcrStatus = status;
      this.getOPCRsByDU(
        this.$store.state.data.cycle,
        this.$store.state.data.selectedCampus.id
      );
    },
    templateReport() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/Template",
        routeVariables: [this.$store.state.data.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    generateKPIReport(groupCampus) {
      if (groupCampus === "all") {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/PrePlanning/KPI/Template",
          routeVariables: [this.$store.state.data.cycle],
        });
      } else {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/PrePlanning/Campus/Kpi",
          routeVariables: [this.$store.state.data.cycle, groupCampus],
        });
      }
      this.$bvModal.show("print-options-modal");
    },
    generateCascadeReport(groupCampus) {
      if (groupCampus === "all") {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/PrePlanning/All/KPI",
          routeVariables: [this.$store.state.data.cycle],
        });
      } else {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/PrePlanning/Cascaded/Kpi",
          routeVariables: [this.$store.state.data.cycle, groupCampus],
        });
      }
      this.$bvModal.show("print-options-modal");
    },
    generateCampusLIB(groupCampus) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/Campus/LIB",
        routeVariables: [groupCampus, this.$store.state.data.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    generateSystemLIB() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/System/LIB",
        routeVariables: [this.$store.state.data.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    generateSystemKPI() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/System/Kpi",
        routeVariables: [this.$store.state.data.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    generateApprovedKPI() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/Target/Approved",
        routeVariables: [this.$store.state.data.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    deleteTag(row, parent) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("planningtarget/RemoveTags", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = parent.tags.findIndex((x) => x.id == row.id);
              parent.tags.splice(index, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    getTags(target) {
      target.tags = [];
      this.$store
        .dispatch("planningtarget/GetTagsByTarget", target.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          target.tags = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getTagsByTarget(x){
      x.showTargets = !x.showTargets;
      this.$forceUpdate();
      if (x.showTargets) {
        x.targetLoading = true;
        for await (const item of x.details) {
          await this.getTags(item);
        }
        setTimeout(() => {
          x.targetLoading = false;
          this.$forceUpdate();
        }, 500);
      }
    }
  },
};
</script>

<template>
  <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
    <PageHeader :title="title" :items="items" />
    <b-modal
      id="update-target-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form
        @submit.prevent="onUpdateTarget"
        class="needs-validation"
        ref="targetForm"
      >
        <div>
          <label for="">Target Description</label>
          <textarea
            class="form-control"
            placeholder="Type Target Description Here..."
            rows="5"
            v-model.lazy="pp.description"
            :class="{
              'is-invalid': submitted && $v.pp.description.$error,
            }"
          ></textarea>
        </div>
        <!-- <div class="mt-3">
                    <label for="">Points</label>
                    <masked-input
                        autocomplete="off"
                        id="q1"
                        type="text"
                        v-model.lazy="pp.points"
                        placeholder="Enter Points ..."
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && $v.pp.points.$error,
                        }"
                        :mask="currencyMask"
                    ></masked-input>
                </div> -->
        <div class="my-3">
          <label for="">Quarterly Target</label>
          <template v-if="selectedParent && selectedParent.allowText">
            <template v-for="x in 4" >
              <div class="mb-2" :key="x">
                <input
                  type="text"
                  class="form-control w-100 text-center"
                  :placeholder="`Quarter ${x}`"
                  v-model="pp[`q${x}Text`]"
                  :class="{
                    'is-invalid': submitted && !pp[`q${x}Text`],
                  }"
                />
              </div>
            </template>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-md-3">
                <masked-input
                  type="text"
                  class="form-control w-100 text-center"
                  placeholder="Quarter 1"
                  v-model.lazy="pp.q1"
                  :mask="currencyMask"
                  :class="{
                    'is-invalid': submitted && $v.pp.q1.$error,
                  }"
                ></masked-input>
                <div class="text-center">
                  <small>Quarter 1</small>
                </div>
              </div>
              <div class="col-md-3">
                <masked-input
                  type="text"
                  class="form-control w-100 text-center"
                  placeholder="Quarter 2"
                  v-model.lazy="pp.q2"
                  :mask="currencyMask"
                  :class="{
                    'is-invalid': submitted && $v.pp.q2.$error,
                  }"
                ></masked-input>
                <div class="text-center">
                  <small>Quarter 2</small>
                </div>
              </div>
              <div class="col-md-3">
                <masked-input
                  type="text"
                  class="form-control w-100 text-center"
                  placeholder="Quarter 3"
                  v-model.lazy="pp.q3"
                  :mask="currencyMask"
                  :class="{
                    'is-invalid': submitted && $v.pp.q3.$error,
                  }"
                ></masked-input>
                <div class="text-center">
                  <small>Quarter 3</small>
                </div>
              </div>
              <div class="col-md-3">
                <masked-input
                  type="text"
                  class="form-control w-100 text-center"
                  placeholder="Quarter 4"
                  v-model.lazy="pp.q4"
                  :mask="currencyMask"
                  :class="{
                    'is-invalid': submitted && $v.pp.q4.$error,
                  }"
                ></masked-input>
                <div class="text-center">
                  <small>Quarter 4</small>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button
            type="button"
            class="btn btn-link"
            @click="$bvModal.hide('update-target-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="opcr-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div v-if="loadOPCR" class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-if="!loadOPCR && opcrs.length > 0">
        <div
          v-for="opcr in opcrs"
          :key="opcr.id"
          class="mb-2 border"
          :class="{ 'border-success': opcr.status.toUpperCase() === 'POSTED' }"
        >
          <div class="d-flex justify-content-between align-items-center p-2">
            <div>
              <h5 class="mb-0">{{ opcr.title }}</h5>
              <small v-if="opcr.isSupplemental" class="text-success"
                ><b>Supplemental</b></small
              >
            </div>
            <div>
              <b-dropdown
                id="dropdown-dropleft"
                right
                variant="purple btn-sm"
                toggle-class="text-decoration-none me-2"
                menu-class="dropdown-menu-end"
                no-caret
              >
                <template #button-content>
                  <i class="bx bx-printer"></i>
                </template>
                <b-dropdown-item @click="printOPCR(opcr.id)"
                  >OPCR</b-dropdown-item
                >
                <b-dropdown-item @click="printDULIB(opcr.id)"
                  >LIB</b-dropdown-item
                >
                <b-dropdown-item @click="printPPMP(opcr.id)"
                  >PPMP</b-dropdown-item
                >
              </b-dropdown>
              <button
                type="button"
                class="btn btn-warning rounded-pill btn-sm"
                title="Return OPCR"
                @click="returnOPCR(opcr)"
                v-if="opcr.status.toUpperCase() === 'POSTED' && !opcr.imported"
              >
                <i class="bx bx-revision"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loadOPCR && opcrs.length == 0" class="text-center">
        <h5>No OPCR Found</h5>
      </div>
    </b-modal>
    <b-modal
      id="return-modal"
      title="Return Remarks"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="returnOPCRSubmit" class="needs-validation">
        <b-row>
          <b-col>
            <div class="mb-3">
              <label for="description">Remarks </label>
              <textarea
                id="description"
                rows="3"
                v-model="returnForm.remarks"
                placeholder="Enter Remarks..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.returnForm.remarks.$error,
                }"
              ></textarea>
              <div
                v-if="submitted && $v.returnForm.remarks.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.returnForm.remarks.required"
                  >This value is required.</span
                >
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Return API</button>
          <button
            type="button"
            class="btn btn-link"
            @click="$bvModal.hide('return-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <b-tabs nav-class="nav-tabs-custom" content-class="pt-3 pb-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">By Delivery Unit</span>
        </template>
        <div class="d-flex align-items-center justify-content-between">
          <div id="tickets-table_filter" class="dataTables_filter me-1">
            <label class="d-inline-flex align-items-center mb-0">
              <b-form-input
                autocomplete="off"
                v-model.lazy="filterDUs"
                type="search"
                placeholder="Search Delivery Unit..."
                class="form-control"
              ></b-form-input>
            </label>
          </div>
          <!-- <div>
            <div class="mb-1">
              <p style="line-height: 14px" class="mb-0">
                With OPCR Total:
                <span class="font-size-18 text-warning">{{ totalOPCR }}</span>
              </p>
            </div>
            <div>
              <p style="line-height: 14px" class="mb-0">
                Without OPCR Total:
                <span class="font-size-18 text-warning">{{
                  campusTemplates.length - totalOPCR
                }}</span>
              </p>
            </div>
          </div> -->
        </div>
        <div class="my-3">
          <div v-if="campusBusy">
            <h3>Loading...</h3>
          </div>
          <div v-if="campusTemplates.length == 0 && !campusBusy">
            <h3>No data found...</h3>
          </div>
          <div v-if="campusTemplates.length > 0 && filteredOffices.length == 0">
            <h3>Search not found</h3>
          </div>
          <div v-if="campusTemplates.length > 0">
            <ul>
              <li v-for="y in filteredOffices" :key="y.officeId">
                <span class="text-warning font-size-14">{{
                  y.officeName
                }}</span>
                <ul>
                  <li
                    v-for="x in filteredDUs(y.deliveryUnits)"
                    :key="`${y.officeId}du${x.deliveryUnitId}`"
                    class="w-100 hover-toggle mb-2"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="d-inline-block">
                        <a
                          href="javascript:void(0);"
                          class="font-size-18 text-dark d-inline"
                          @click="viewTargets(x)"
                          >{{ x.deliveryUnit.name }}({{ x.count }})
                          <i
                            class="bx bx-caret-right rotate"
                            :class="{ 'rotate-90': x.rotateChevy }"
                            v-if="x.count != 0"
                          >
                          </i>
                        </a>
                      </div>
                      <!-- <div class="d-flex">
                        <button
                          class="btn btn-pink btn-sm"
                          v-if="x.rotateChevy && x.targets.length"
                          @click="showOPCRs(x)"
                        >
                          <i class="bx bx-repost me-1 d-inline"></i>OPCRs
                        </button>
                      </div> -->
                    </div>
                    <b-collapse class="pt-3" :visible="x.rotateChevy">
                      <template v-if="x.targetLoading">
                        <div class="d-flex justify-content-center">
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <b-tabs
                          content-class="pt-3 pb-3 text-muted"
                          v-model="x.tabIndex"
                          nav-class="nav-tabs-custom"
                        >
                          <div v-for="(type, index) in tabOptions" :key="index">
                            <b-tab
                              v-if="checkTab(x.targets, type)"
                              @click="
                                x.filter = '';
                                x.tabSelect = type;
                              "
                            >
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i
                                    class="mdi mdi-clock-time-four-outline"
                                  ></i>
                                </span>
                                <span class="d-none d-sm-inline-block">{{
                                  type
                                }}</span>
                              </template>
                              <div>
                                <div
                                  id="tickets-table_filter"
                                  class="dataTables_filter mb-3"
                                >
                                  <label
                                    class="d-inline-flex align-items-center mb-0"
                                  >
                                    <b-form-input
                                      autocomplete="off"
                                      v-model="x.filter"
                                      type="search"
                                      placeholder="Search KPI, Target..."
                                      class="form-control"
                                    ></b-form-input>
                                  </label>
                                </div>
                                <b-card-body class="p-0">
                                  <div
                                    v-if="filteredTargets(x).length == 0"
                                    class="text-center"
                                  >
                                    <h5 v-if="x.filter">Search not found</h5>
                                    <h5 v-else>No data available</h5>
                                  </div>
                                  <div
                                    role="tablist"
                                    v-for="(kpi, kpiIndex) in filteredTargets(
                                      x
                                    )"
                                    :key="kpi.indicatorItemId"
                                  >
                                    <b-card
                                      no-body
                                      class="mb-2"
                                      :style="{
                                        'z-index':
                                          filteredTargets(x).length - kpiIndex,
                                      }"
                                    >
                                      <b-card-header
                                        header-tag="header"
                                        role="tab"
                                      >
                                        <div
                                          class="d-flex justify-content-between align-items-center cursor-pointer"
                                          @click="getTagsByTarget(kpi)"
                                        >
                                          <div class="me-3">
                                            <div>
                                              <div>
                                                <b class="text-white">
                                                  {{ kpi.indicatorItemName }}
                                                </b>
                                              </div>
                                              <small>
                                                Targets Available ({{
                                                  kpi.details.length
                                                }})
                                              </small>
                                            </div>
                                          </div>
                                          <div
                                            class="d-flex align-items-center"
                                          >
                                            <div>
                                              <span
                                                class="d-flex align-items-center"
                                                ><small v-if="!kpi.showTargets"
                                                  >Click here to expand
                                                </small>
                                                <div
                                                  class="d-flex align-items-center"
                                                >
                                                  <i
                                                    class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                    :class="{
                                                      'rotate-90':
                                                        kpi.showTargets,
                                                    }"
                                                  ></i>
                                                </div>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </b-card-header>
                                    </b-card>
                                    <b-collapse
                                      :visible="kpi.showTargets"
                                      :accordion="`kpi-accordion-${type}-${kpiIndex}`"
                                      role="tabpanel"
                                    >
                                      <b-card-body class="ps-5 pe-0 pt-3">
                                        <div class="d-flex align-items-center">
                                          <h6 class="card-title text-muted">
                                            Target List
                                          </h6>
                                        </div>
                                        <div v-if="x.targetLoading">
                                          Loading...
                                        </div>
                                        <div v-else>
                                          <div
                                            class="card mb-1 mt-1"
                                            v-for="(y, yIndex) in kpi.details"
                                            :key="`target-${kpi.indicatorItemId}-${y.id}`"
                                            :id="`target-${kpi.indicatorItemId}-${y.id}`"
                                            :style="{
                                              'z-index':
                                                kpi.details.length +
                                                10 -
                                                yIndex,
                                            }"
                                          >
                                            <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"/>
                                            <b-card-header>
                                              <div
                                                class="d-flex justify-content-between"
                                              >
                                                <div
                                                  class="d-flex align-items-center"
                                                >
                                                  <div
                                                    class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                                    style="min-width: 30px"
                                                  >
                                                    <h3
                                                      class="mb-0 position-relative"
                                                    >
                                                      {{ yIndex + 1 }}
                                                    </h3>
                                                  </div>
                                                  <div>
                                                    <div
                                                      class="d-flex align-items-center"
                                                    >
                                                      <h5
                                                        class="card-title font-size-16 mb-0 mt-1 me-1 text-info"
                                                      >
                                                        {{ y.description }}
                                                      </h5>
                                                    </div>
                                                    <div class="py-1"  v-if="y.tags.length">
                                                        <b class="me-1">Tags: </b>
                                                        <div class="d-inline">
                                                          <span
                                                            class="badge bg-success me-1 font-size-14"
                                                            v-for="z in y.tags"
                                                            :key="z.id"
                                                            :title="z.tag"
                                                          >
                                                            {{ z.tag
                                                            }}<span
                                                              class="ms-3 cursor-pointer"
                                                              @click="deleteTag(z, y)"
                                                              ><i
                                                                class="bx bx-x-circle text-danger"
                                                              ></i
                                                            ></span>
                                                          </span>
                                                        </div>
                                                    </div>
                                                    <div
                                                      class="d-flex align-items-center gap-2"
                                                    >
                                                      <div>
                                                        <small
                                                          ><a
                                                            href="javascript: void(0);"
                                                            class="text-warning d-flex align-items-center"
                                                            @click="getApiList(y)"
                                                          >
                                                            View API's
                                                          </a>
                                                        </small>
                                                      </div>
                                                      |
                                                      <div>
                                                        <small
                                                          ><a
                                                            href="javascript: void(0);"
                                                            class="text-pink d-flex align-items-center"
                                                            @click="getPerformanceRating(y, 'planning')"
                                                          >
                                                            View Performance
                                                            Rubric
                                                          </a>
                                                        </small>
                                                      </div>
                                                      |
                                                      <div>
                                                        <small
                                                          ><a
                                                            href="javascript: void(0);"
                                                            class="text-danger d-flex align-items-center"
                                                            title="Delete Target"
                                                            @click="
                                                              deleteTargetItem(
                                                                y,
                                                                kpi,
                                                                x
                                                              )
                                                            "
                                                          >
                                                            <i
                                                              class="bx bx-trash font-size-14"
                                                            ></i>
                                                          </a>
                                                        </small>
                                                      </div>
                                                      |
                                                      <div>
                                                        <small
                                                          ><a
                                                            href="javascript: void(0);"
                                                            class="text-primary d-flex align-items-center"
                                                            title="Update Target"
                                                            @click="
                                                              updateTargetItem(
                                                                y,
                                                                kpi,
                                                                x
                                                              )
                                                            "
                                                          >
                                                            <i
                                                              class="bx bx-edit font-size-14"
                                                            ></i>
                                                          </a>
                                                        </small>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="d-flex">
                                                  <table
                                                    class="table mb-0 table-bordered"
                                                  >
                                                    <template v-if="y.planningMainTarget.indicatorItem.allowText">
                                                      <tr>
                                                        <td class="px-3 text-center">
                                                          Cascaded Target
                                                        </td>
                                                        <td
                                                          class="text-center px-3 text-warning"
                                                        >
                                                          {{ y.cascadedTargetText }}
                                                        </td>
                                                      </tr>
                                                      <template v-for="x in 4">
                                                        <tr :key="x">
                                                          <td class="px-3 text-center">
                                                            Quarter {{ x }}
                                                          </td>
                                                          <td
                                                            class="text-center px-3 text-warning"
                                                          >
                                                            {{
                                                              y[`q${x}Text`]
                                                            }}
                                                          </td>
                                                        </tr>
                                                      </template>
                                                    </template>
                                                    <template v-else>
                                                      <tr>
                                                        <th
                                                          style="width: 150px"
                                                          class="text-center"
                                                        >
                                                          Cascaded Target
                                                        </th>
                                                        <!-- <th style="width:70px;" class="text-center">Pts.</th> -->
                                                        <th
                                                          style="width: 70px"
                                                          class="text-center"
                                                        >
                                                          Q1
                                                        </th>
                                                        <th
                                                          style="width: 70px"
                                                          class="text-center"
                                                        >
                                                          Q2
                                                        </th>
                                                        <th
                                                          style="width: 70px"
                                                          class="text-center"
                                                        >
                                                          Q3
                                                        </th>
                                                        <th
                                                          style="width: 70px"
                                                          class="text-center"
                                                        >
                                                          Q4
                                                        </th>
                                                      </tr>
                                                      <tr>
                                                        <td
                                                          class="text-center p-0 text-warning"
                                                        >
                                                          {{
                                                            y.planningMainTarget
                                                              .isPercentage
                                                              ? `${y.cascadedTarget}%`
                                                              : y.cascadedTarget
                                                          }}
                                                        </td>
                                                        <!-- <td class="text-center p-0 text-warning">
                                                                                {{y.points}}
                                                                            </td> -->
                                                        <td
                                                          class="text-center p-0 text-warning"
                                                        >
                                                          {{
                                                            y.planningMainTarget
                                                              .isPercentage
                                                              ? `${y.q1}%`
                                                              : y.q1
                                                          }}
                                                        </td>
                                                        <td
                                                          class="text-center p-0 text-warning"
                                                        >
                                                          {{
                                                            y.planningMainTarget
                                                              .isPercentage
                                                              ? `${y.q2}%`
                                                              : y.q2
                                                          }}
                                                        </td>
                                                        <td
                                                          class="text-center p-0 text-warning"
                                                        >
                                                          {{
                                                            y.planningMainTarget
                                                              .isPercentage
                                                              ? `${y.q3}%`
                                                              : y.q3
                                                          }}
                                                        </td>
                                                        <td
                                                          class="text-center p-0 text-warning"
                                                        >
                                                          {{
                                                            y.planningMainTarget
                                                              .isPercentage
                                                              ? `${y.q4}%`
                                                              : y.q4
                                                          }}
                                                        </td>
                                                      </tr>
                                                    </template>
                                                  </table>
                                                </div>
                                              </div>
                                              <div v-if="y.rotateChevy">
                                                <hr />
                                                <div
                                                  class="d-flex justify-content-between align-items-center"
                                                >
                                                  <h5>List of API's</h5>
                                                  <a
                                                    href="javascript:void(0);"
                                                    class="font-size-20 text-white"
                                                    @click="
                                                      y.rotateChevy = false
                                                    "
                                                    ><i class="bx bx-x"></i
                                                  ></a>
                                                </div>
                                                <div
                                                  class="text-center"
                                                  v-if="
                                                    !y.apiLoading &&
                                                    y.apiList.length == 0
                                                  "
                                                >
                                                  <h5>No API(s) found</h5>
                                                </div>
                                                <div
                                                  class="text-center"
                                                  v-if="y.apiLoading"
                                                >
                                                  <h5>Loading....</h5>
                                                </div>
                                                <div
                                                  class="row"
                                                  v-if="
                                                    !y.apiLoading &&
                                                    y.apiList.length > 0
                                                  "
                                                >
                                                  <div class="col-md-12">
                                                    <table
                                                      class="table table-bordered"
                                                    >
                                                      <thead>
                                                        <tr>
                                                          <th>
                                                            API Description
                                                          </th>
                                                          <th width="220px">
                                                            Total Resources
                                                          </th>
                                                          <th
                                                            width="90px"
                                                            class="text-center"
                                                          >
                                                            Action
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <template
                                                          v-for="w in y.apiList"
                                                        >
                                                          <tr
                                                            :key="`apiList-x${x.id}-y${y.officeId}-w${w.id}`"
                                                          >
                                                            <td>
                                                              <div>
                                                                <a
                                                                  href="javascript:void(0);"
                                                                  class="text-white"
                                                                  @click="
                                                                    getResource(
                                                                      w
                                                                    )
                                                                  "
                                                                  >{{
                                                                    w.name
                                                                  }}</a
                                                                >
                                                              </div>
                                                              <div>
                                                                <small
                                                                  class="text-warning cursor-pointer"
                                                                  @click="
                                                                    getResource(
                                                                      w
                                                                    )
                                                                  "
                                                                  >View
                                                                  Resources</small
                                                                >
                                                              </div>
                                                            </td>
                                                            <td>
                                                              {{
                                                                formatCurrency(
                                                                  w.total
                                                                )
                                                              }}
                                                            </td>
                                                            <td
                                                              class="align-middle"
                                                            >
                                                              <div
                                                                class="d-flex justify-content-center"
                                                              >
                                                                <button
                                                                  type="button"
                                                                  @click="
                                                                    removeApi(
                                                                      w,
                                                                      y
                                                                    )
                                                                  "
                                                                  class="btn btn-clear px-1"
                                                                  title="Remove API"
                                                                >
                                                                  <i
                                                                    class="bx bx-trash text-danger font-size-18"
                                                                  ></i>
                                                                </button>
                                                                <button
                                                                  type="button"
                                                                  @click="
                                                                    printPPMPAPI(
                                                                      w.id
                                                                    )
                                                                  "
                                                                  class="btn btn-clear px-1"
                                                                  title="Print PPMP"
                                                                >
                                                                  <i
                                                                    class="bx bx-printer text-purple font-size-18"
                                                                  ></i>
                                                                </button>
                                                              </div>
                                                            </td>
                                                          </tr>
                                                          <tr
                                                            v-if="
                                                              w.viewResource
                                                            "
                                                            :key="`apiListRrs-x${x.id}-y${y.officeId}-w${w.id}`"
                                                          >
                                                            <td
                                                              colspan="4"
                                                              v-if="
                                                                !w.resourceLoading &&
                                                                w.resourceList
                                                                  .length == 0
                                                              "
                                                              class="broken-border text-center"
                                                            >
                                                              No data found
                                                            </td>
                                                            <td
                                                              colspan="4"
                                                              v-if="
                                                                w.resourceLoading
                                                              "
                                                              class="broken-border text-center"
                                                            >
                                                              Loading...
                                                            </td>
                                                            <td
                                                              colspan="4"
                                                              v-if="
                                                                !w.resourceLoading &&
                                                                w.resourceList
                                                                  .length > 0
                                                              "
                                                            >
                                                              <div
                                                                v-for="z in w.resourceList"
                                                                :key="`resourceList-x${x.id}-y${y.officeId}-w${w.id}-z${z.id}`"
                                                                class="ms-3 mb-1 p-3 broken-border"
                                                              >
                                                                <div
                                                                  class="d-flex align-items-center justify-content-between"
                                                                >
                                                                  <div
                                                                    class="d-flex align-items-center"
                                                                  >
                                                                    <div
                                                                      class="font-size-20 text-yellow"
                                                                    >
                                                                      {{
                                                                        z.totalQuantity
                                                                      }}
                                                                    </div>
                                                                    <i
                                                                      class="bx bx-x font-size-20 me-2 text-yellow"
                                                                    ></i>
                                                                    <div>
                                                                      {{
                                                                        z.itemName
                                                                      }}
                                                                      <div>
                                                                        <small
                                                                          >{{
                                                                            z.description
                                                                          }}</small
                                                                        >
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="text-center"
                                                                  >
                                                                    <div
                                                                      class="font-size-20 text-yellow mb-0"
                                                                    >
                                                                      {{
                                                                        formatCurrency(
                                                                          z.totalWithInflation
                                                                        )
                                                                      }}
                                                                    </div>
                                                                    <small>
                                                                      ({{
                                                                        formatCurrency(
                                                                          z.unitCost
                                                                        )
                                                                      }})
                                                                    </small>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        </template>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </b-card-header>
                                          </div>
                                        </div>
                                      </b-card-body>
                                    </b-collapse>
                                  </div>
                                </b-card-body>
                              </div>
                            </b-tab>
                          </div>
                        </b-tabs>
                      </template>
                    </b-collapse>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">By KPI</span>
        </template>
        <PlanningTemplate
          :itemClassifications="itemClassifications"
          :indicators="indicators"
          @templateReport="templateReport"
          @generateKPIReport="generateKPIReport"
          @generateCascadeReport="generateCascadeReport"
          @generateCampusLIB="generateCampusLIB"
          @generateSystemLIB="generateSystemLIB"
          @generateSystemKPI="generateSystemKPI"
          @generateApprovedKPI="generateApprovedKPI"
        />
      </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
    <PlanningRatingScale ref="PlanningRatingScale"></PlanningRatingScale>
  </Layout>
</template>